export default {
  columns: {
    title: 'Tytuł',
    image: 'Obraz',
    button_url: 'URL przycisku',
    button_text: 'Tekst przycisku',
    description: 'Opis',
    visible: 'Widoczny',
    actions: 'Akcje',
  },
  buttons: {
    create_post: 'Utwórz post',
    edit: 'Edytuj',
    delete: 'Usuń',
    cancel: 'Anuluj',
    confirm: 'Potwierdź',
  },
  title: 'Wyróżnione posty',
  delete_confirmation: 'Czy na pewno chcesz usunąć ten post?',
};
